import './weaponSelector.css';
export interface WeaponOption {id:string;label:string;detail?:string;kind:'rifle'|'blade'|'minigun'}
const paths={rifle:'M3 12h24v3H13l-2 5H7l1-5H3z M13 8h7v3h-7z',blade:'M8 23 23 4l3-1-1 4L11 24z M5 18l10 8',minigun:'M4 10h9v12H4z M13 11h16v3H13 M13 16h16v3H13 M7 6h8v4'};
/** Stable item order, direct number keys and wrapping Q/E share one selection
 * path. Hosts own equipment and input context; the UI never grants inventory. */
export class WeaponSelector {
 readonly element=document.createElement('aside');
 private options:readonly WeaponOption[]=[];
 private selected='';private key='';private cards:HTMLButtonElement[]=[];
 private readonly list=document.createElement('div');
 private readonly current=document.createElement('span');
 constructor(private readonly choose:(id:string)=>void){
  this.element.className='weapon-selector';this.element.hidden=true;this.element.setAttribute('aria-label','Weapon selection');
  const header=document.createElement('div');header.className='weapon-selector-heading';
  for(const [label,delta]of [['Q',-1],['E',1]]as const){
   const button=document.createElement('button');button.type='button';button.textContent=label;button.title=delta<0?'Previous weapon':'Next weapon';
   button.onclick=()=>this.cycle(delta);header.append(button);
  }
  this.current.className='weapon-selector-current';this.current.setAttribute('aria-live','polite');header.insertBefore(this.current,header.lastChild);
  this.list.className='weapon-selector-options';this.element.append(header,this.list);document.body.append(this.element);
 }
 update(options:readonly WeaponOption[],selected:string,visible:boolean):void {
  this.element.hidden=!visible||options.length===0;this.options=options;this.selected=selected;
  const key=options.map(o=>o.id+o.label+o.kind+o.detail).join('|');
  if(key!==this.key){
   this.key=key;this.list.replaceChildren();this.cards=options.map((o,i)=>{
    const b=document.createElement('button');b.type='button';b.title=`${i<10?`${(i+1)%10} · `:''}${o.label}${o.detail?' — '+o.detail:''}`;b.setAttribute('aria-label',b.title);
    b.innerHTML=`<kbd>${i<10?(i+1)%10:''}</kbd><svg viewBox="0 0 32 32" aria-hidden="true"><path d="${paths[o.kind]}"/></svg><span></span>`;
    b.querySelector('span')!.textContent=o.label;b.onclick=()=>this.choose(o.id);this.list.append(b);return b;
   });
  }
  this.current.textContent=options.find(o=>o.id===selected)?.label??'Unarmed';
  this.cards.forEach((card,i)=>card.setAttribute('aria-pressed',String(options[i].id===selected)));
 }
 handleInput(input:{wasPressed(key:string):boolean}):void {
  if(this.element.hidden)return;
  for(let i=0;i<Math.min(10,this.options.length);i++)if(input.wasPressed(`Digit${(i+1)%10}`)){this.choose(this.options[i].id);return;}
  if(input.wasPressed('KeyQ'))this.cycle(-1);else if(input.wasPressed('KeyE'))this.cycle(1);
 }
 private cycle(delta:number):void {
  const n=this.options.length;if(!n)return;
  const i=this.options.findIndex(o=>o.id===this.selected);
  this.choose(this.options[((i<0?(delta>0?-1:0):i)+delta+n)%n].id);
 }
}
